export default class ContactUsTopic {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.contact_us_topic = {
      translations: [
        { id: null, name: '', lang: 'ar' },
        { id: null, name: '', lang: 'en' }
      ]
    }
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.contact_us_topic.translations[0].id = itemAr ? itemAr.id : null
      this.contact_us_topic.translations[0].name = itemAr ? itemAr.name : ''
      this.contact_us_topic.translations[1].id = itemEn ? itemEn.id : null
      this.contact_us_topic.translations[1].name = itemEn ? itemEn.name : ''
    } else {
      this.setInitialValue()
    }
  }
}
